import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";

export const FinalCta = () => (
  <section className="bg-forest relative overflow-hidden" data-testid="final-cta-section">
    <div className="absolute inset-0 grain" aria-hidden="true" />
    <div className="relative max-w-4xl mx-auto px-5 sm:px-8 py-24 lg:py-32 text-center">
      <Reveal>
        <h2 className="font-serif font-medium text-ivory text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          Ready to understand your health differently?
        </h2>
        <p className="mt-6 text-ivory/75 text-base sm:text-lg">
          Start with your InSight Health Profile.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to="/health-profile"
            data-testid="final-cta-profile"
            className="inline-flex justify-center items-center rounded-full bg-ivory text-forest px-9 py-4 text-sm font-semibold tracking-wide hover:bg-white transition-colors duration-300"
          >
            Begin Your Health Profile
          </Link>
          <Link
            to="/health-profile"
            data-testid="final-cta-consult"
            className="inline-flex justify-center items-center rounded-full px-9 py-4 text-sm font-semibold tracking-wide text-ivory border border-ivory/40 hover:border-goldlight hover:text-goldlight transition-colors duration-300"
          >
            Request a Consultation
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
